/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Fond_Jay_RollInputs */

const en_weak_fond_jay_roll = /** @type {(inputs: Weak_Fond_Jay_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_weak_fond_jay_roll = /** @type {(inputs: Weak_Fond_Jay_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Weak_Fond_Jay_RollInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const weak_fond_jay_roll = /** @type {((inputs?: Weak_Fond_Jay_RollInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Fond_Jay_RollInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weak_fond_jay_roll(inputs)
	return de_weak_fond_jay_roll(inputs)
});